import styled, { DefaultTheme } from 'styled-components';
import { Card, Button, Typography, Collapse } from 'antd';

declare module 'styled-components' {
  export interface DefaultTheme {
    mode?: 'light' | 'dark';
  }
}

const getThemeValue = <T,>(props: { theme?: DefaultTheme }, darkValue: T, lightValue: T): T => {
  return props.theme?.mode === 'dark' ? darkValue : lightValue;
};

export const Container = styled.div`
  padding: 16px;
  background: ${(props) => getThemeValue(props, '#171923', 'transparent')};
  color: ${(props) => getThemeValue(props, '#fff', 'inherit')};
`;

export const HeaderSection = styled.div`
  margin-bottom: 24px;
`;

export const DashboardTitle = styled(Typography.Title)`
  margin: 0 !important;
`;

export const SectionCard = styled(Card)`
  border-radius: 12px;
  border: 1px solid ${(props) => getThemeValue(props, '#718096', '#DCDCDC')};
  background: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')};

  .ant-card-body {
    padding: 20px;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const SectionTitle = styled(Typography.Title)`
  margin: 0 !important;
  color: ${(props) => getThemeValue(props, '#fff', '#1a202c')} !important;
  font-size: 18px !important;
  font-weight: 700 !important;
`;

export const CloseButton = styled(Button)`
  border-radius: 8px !important;
`;

export const StyledCollapse = styled(Collapse)`
  .ant-collapse-panel > .ant-collapse-body {
    padding: 0 !important;
  }
`;

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const SectionText = styled(Typography.Text)`
  display: block;
  color: ${(props: any) => (props.theme?.mode === 'dark' ? '#e2e8f0' : '#595959')};
  font-size: 14px;
  margin-bottom: 12px;
  line-height: 1.6;
`;

export const TasksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TaskItem = styled.div`
  padding: 12px;
  border-radius: 8px;
  background: ${(props: any) => (props.theme?.mode === 'dark' ? '#2d3748' : '#f7fafc')};
  border: 1px solid ${(props: any) => (props.theme?.mode === 'dark' ? '#4a5568' : '#e8e8e8')};
`;

export const TaskText = styled(Typography.Text)`
  color: ${(props: any) => (props.theme?.mode === 'dark' ? '#e2e8f0' : '#595959')};
  font-size: 14px;
`;

export const AnnouncementsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const AnnouncementItem = styled.div`
  padding: 12px;
  border-radius: 8px;
  background: ${(props: any) => (props.theme?.mode === 'dark' ? '#2d3748' : '#f7fafc')};
  border: 1px solid ${(props: any) => (props.theme?.mode === 'dark' ? '#4a5568' : '#e8e8e8')};
`;

export const AnnouncementText = styled(Typography.Text)`
  color: ${(props: any) => (props.theme?.mode === 'dark' ? '#e2e8f0' : '#595959')};
  font-size: 14px;
`;
